import React from 'react';
import { CardHeader, CardContent, Grid, Box, Divider, IconButton } from '@material-ui/core';
import { useTranslate } from 'ra-core';
import { usePermissions } from 'react-admin';
import { useUploader } from '../Uploader';
import UploaderDashboardItem from './UploaderDashboardItem';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import ReplayIcon from '@material-ui/icons/Replay';

export default function UploaderDashboard() {
    const translate = useTranslate();
    const { permissions } = usePermissions();

    const uploader = useUploader();

    const handleClearFinished = () => {
        uploader.clearFinishedFilesFromUploadQueue();
    }

    const handleRetry = () => {
        uploader.retryToUploadFailedFiles();
    }

    return (
        <>
        {
            permissions?.has('upload-files') && uploader.state.queue.length > 0 && 
            <Grid item xs={12}>
                <Box bgcolor={'background.paper'} borderColor={'primary'} border={1} borderRadius={'borderRadius'} borderColor={'#e0e0e0'}>
                    <CardHeader
                        title={translate(`cmss.resources.file-explorer.uploader.uploading`)}
                        action={
                            <>
                                <IconButton onClick={handleRetry}>
                                    <ReplayIcon/>
                                </IconButton>
                                <IconButton onClick={handleClearFinished}>
                                    <DeleteSweepIcon/>
                                </IconButton>
                            </>
                        }
                    >
                    </CardHeader>
                    <Divider/>
                    <CardContent>
                        <Grid container spacing={2}>
                            {uploader.state.queue.map((queueItem) => 
                                <UploaderDashboardItem key={queueItem.id} path={queueItem.path} progress={queueItem.progress} status={queueItem.status}/>
                            )}
                        </Grid>
                    </CardContent>
                </Box>
            </Grid>
        }
        </>
    );
}